import classes from './Home.module.css';
//import heroImage from '../../../src/assets/images/iphonex.png';
import demo from '../../assets/images/733d788d-46b2-4f99-bc2f-8a5541380130.webp'
import { useTranslation } from 'react-i18next';
const Home = (props) => {
    const {t} = useTranslation();
    return (
        <div id="home" className={classes.Home}>
            <div className="container">
                <div className={[classes.Hero, 'row'].join(' ')}>
                    <div className="col-6">
                        <div className={classes.HeroDescription}>
                            <h1>Red Taxi</h1>
                            {/* <p>Making your Everyday Ride Simpler and Easier.</p> */}
                            <p>{t('home.hero')}</p>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className={classes.HeroImage}>
                            <img src={demo} alt="Red taxi" data-aos="fade-up"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;